import { DataType } from "../../evaluators/DataType";
import { LomaInfo } from "./LomaInfo";

export class LomaVariable<T> extends LomaInfo
{
  variableName:string;
  value:T;
  type:DataType;

  getInfoTitle(){ return this.variableName; }

  static create( name:string, value:number, type:DataType )
  {
    let v = new LomaVariable<number>();
    v.variableName = name;
    v.value = value;
    v.type = type;

    return v;
  }
}